<div  class="card-container"
                                style="position: absolute; top: 40%; width: 100%; display: flex; justify-content: center; z-index: 2;">

                                <div class="card" [ngClass]="{ 
             'horizontal-card': orientation === 'HORIZONTAL', 
             'vertical-card': orientation === 'VERTICAL' 
           }" [ngStyle]="{
             'flex-direction': 
               orientation === 'HORIZONTAL' 
                 ? (alignment === 'RIGHT' ? 'row-reverse' : 'row') 
                 : 'column'
           }" style="width: 100%; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); border-radius: 8px; background: white; display: flex; z-index: -1;">

                                    <!-- Card Header (Image Section) -->
                                    <div class="card-header" [ngStyle]="{
               width: orientation === 'HORIZONTAL' ? '30%' : '100%',
               borderRadius: 
                 orientation === 'HORIZONTAL' 
                   ? (alignment === 'LEFT' ? '8px 0 0 8px' : '0 8px 8px 0') 
                   : '8px 8px 0 0',
               overflow: 'hidden'
             }">
                                        <img *ngIf="fileUrl" [src]="fileUrl" alt="Uploaded media" [ngStyle]="{
                 aspectRatio: templateForm.get('height')?.value==='SHORT_HEIGHT'?'3/1':templateForm.get('cardOrientation')?.value === 'VERTICAL' && templateForm.get('height')?.value === 'MEDIUM_HEIGHT'?'2/1':'3/4',
                 objectFit: 'cover'
               }" style="display: block; width:100%; height:100%;">
                                    </div>

                                    <!-- Card Content -->
                                    <div class="card-content" [ngStyle]="{
                                      width: orientation === 'HORIZONTAL' ? '70%' : '100%',
               padding: '16px',
               display: 'flex',
               flexDirection: 'column',
               justifyContent: 'center',
             }">

                                        <!-- Card Title -->
                                        <!-- Card Title -->
                                        <div class="card-title" [ngStyle]="{
    fontSize: '18px', 
    fontWeight: 'bold', 
    marginBottom: '8px', 
    color: '#333',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '100%'
  }">
                                            <!-- {{ templateForm.get('cardTitle')?.value }} -->
                                            {{cardTitle}}
                                        </div>

                                        <!-- Card Description -->
                                        <!-- <p class="card-description" [ngStyle]="{
                        width: '100%',
                        fontSize: '14px',
                        color: '#6c6b6b', 
                        lineHeight: '1.4', 
                        marginBottom: '12px',
                        padding: '5px',
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        maxWidth: '100%'
                        }">
                                              {{cardDescription}}
                                        </p> -->
                                        <p class="card-description"
                                        [ngStyle]="{
                                          width: '100%',
                                          fontSize: '14px',
                                          color: '#6c6b6b',
                                          lineHeight: '1.4',
                                          marginBottom: '12px',
                                          padding: '5px',
                                          whiteSpace: 'normal',
                                          wordWrap: 'break-word',
                                          overflowWrap: 'break-word',
                                          maxWidth: '100%'
                                        }">

                                        <span [innerHTML]="cardDescription"></span>

                                      </p>


                                        <!-- Suggestion Link -->
                                        <div [ngStyle]="{
                                            display: 'flex', 
                                            justifyContent: (alignment === 'LEFT' && orientation=== 'HORIZONTAL') ? 'flex-start' : (alignment === 'RIGHT' && orientation=== 'HORIZONTAL') ?'flex-end':'center', 
                                            alignItems: 'center', 
                                            height: '100%'
                                        }">
                                            <div>
                                                <div
                                                    *ngFor="let suggestion of suggestionsFormArray.controls; let i = index">
                                                    <div *ngIf="suggestion.get('text')?.value"
                                                        style="margin-top: 10px; ">
                                                        <a nz-button
                                                            [nzType]="(this.templateType==='rich_card' || this.templateType==='carousel') ? 'link' : 'primary'"
                                                            [href]="suggestion.get('text')?.value" target="_blank"
                                                            [ngStyle]="{
                                    color: '#007bff',  
                                    fontSize: '14px',
                                    textAlign: alignment === 'LEFT' ? 'flex-start' : alignment === 'RIGHT' ?'flex-end':'center'
                                }">
                                                            <span nz-icon
                                                                [nzType]="(suggestion.get('type')?.value==='view_location_query' || suggestion.get('type')?.value==='share_location' || suggestion.get('type')?.value=== 'view_location_latlong')?'environment':(suggestion.get('type')?.value==='dialer_action')?'phone':(suggestion.get('type')?.value==='url_action')? 'global': (suggestion.get('type')?.value==='calendar_event')? 'calendar' :''"
                                                                nzTheme="outline"></span>
                                                            {{ suggestion.get('text')?.value }}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>